import { Grid, Typography } from "@mui/material";
import Image from "mui-image";

import { Card, /*PrimaryBorderButton,*/ PrimaryBackgroundButton } from "../tctt.js";

const CycloptCard = ({ product, isBought }) => (
	<Card
		key={product.id}
		title={
			<Image src={product.image} alt={product.title} width="100%" fit="contain" style={{ padding: "10px 5px", maxHeight: "80px" }} />
		}
		titleBackgroundColor={product.color}
		width="300px"
		height="350px"
		boxShadow="0px 1px 5px rgba(158, 158, 158, 1)"
	>
		<Grid item width="100%" display="flex" flexDirection="column" alignItems="center">
			<Typography sx={{fontSize: "large", fontWeight: "bold"}}>{product.title}</Typography>
			{/* Use the full description space while Learn More is hidden. */}
			<Grid width="100%" height="150px" mt={1}>
				<Typography fontSize={16}>{product.shortDescription}</Typography>
			</Grid>
			<Grid container width="100%" marginTop="auto" spacing={1} justifyContent="center">
				{product.id === "configurator" ? (
						<PrimaryBackgroundButton title="Manage Plans" width="100%" onClick={() => { window.location.href = product.url; }} />
					) : (isBought || product.field === "always"
						? <PrimaryBackgroundButton title="Explore" width="100%" onClick={() => { window.location.href = product.url; }} />
						: <PrimaryBackgroundButton title="Buy Now" width="100%" onClick={() => { window.location.href = "https://pricing.cyclopt.com" }} />
					)
				}
				{/* {product.learnMore && (
					<PrimaryBorderButton title="Learn More" width="100%" onClick={() => { window.location.href = product.learnMore; }} />
				)} */}
			</Grid>
		</Grid>
	</Card>
);

export default CycloptCard;
